import React from 'react';
import { inject, observer } from 'mobx-react';
import { withStyles } from '@material-ui/core/styles';
import ModalEvahIa from '../../pages/Atendimento/EvahIa/ModalEvahIa';
import EvahIaIcon from '../Icon/EvahIaIcon';
import ConfirmAlertModal from '../ConfirmModal/ConfirmAlertModal';
import Notification from '../Notification';

const styles = {
  evahIaFloatingButton: {
    position: 'fixed',
    bottom: '15px',
    right: '90px',
    width: '64px',
    height: '64px',
    borderRadius: '50%',
    backgroundColor: '#9626AC',
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
    zIndex: 1000,
    transition: 'all 0.3s ease',
    '&:hover': {
      backgroundColor: '#7A1E8A',
      transform: 'scale(1.05)',
    }
  },
  iconContainerEvah: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  soundWaveAnimation: {
    display: 'flex',
    alignItems: 'center',
    gap: '2px',
  },
  wave: {
    width: '3px',
    height: '12px',
    backgroundColor: '#fff',
    borderRadius: '2px',
    animation: 'wave 1.5s ease-in-out infinite',
    '&:nth-child(1)': {
      animationDelay: '0s',
    },
    '&:nth-child(2)': {
      animationDelay: '0.2s',
    },
    '&:nth-child(3)': {
      animationDelay: '0.4s',
    },
  },
  '@keyframes wave': {
    '0%, 40%, 100%': {
      transform: 'scaleY(0.4)',
    },
    '20%': {
      transform: 'scaleY(1)',
    },
  },
};

@inject('prontuarioStore')
@observer
class EvahIaFloatingButton extends React.Component {
  state = {
    evahIaRecordingState: false,
    showCloseAlert: false
  };

  handleModalClose = () => {
    if (this.state.evahIaRecordingState) {
      this.setState({ showCloseAlert: true });
    } else {
      this.setState({ evahIaRecordingState: false });
      this.props.prontuarioStore.closeModalEvahIa();
    }
  }

  handleCancelAlert = () => {
    this.setState({ 
      evahIaRecordingState: false,
      showCloseAlert: false 
    });
    this.props.prontuarioStore.closeModalEvahIa();
  }

  handleConfirmClose = () => {
    this.setState({ showCloseAlert: false });
    this.handleModalMinimize();
  }

  handleModalMinimize = () => {
    this.props.prontuarioStore.minimizeModalEvahIa();
  }

  handleRecordingChange = (isRecording) => {
    this.setState({ evahIaRecordingState: isRecording });
  }
  handleOpenNotification = (message,type) =>{
    this.props.prontuarioStore.openNotification(message,type)
  }
  handleButtonClick = () => {
    if (this.props.prontuarioStore.minimizedModalEvahIa) {
      this.props.prontuarioStore.minimizeModalEvahIa();
    } else {
      this.props.prontuarioStore.openModalEvahIa = true;
    }
  }

  render() {
    const { classes, prontuarioStore } = this.props;
    
    if (!prontuarioStore.sujeitoAtencaoSelectedIA && !prontuarioStore.minimizedModalEvahIa && !prontuarioStore.openModalEvahIa) {
      return null;
    }

    return (
      <>
        {prontuarioStore.minimizedModalEvahIa && (
          <button 
            className={classes.evahIaFloatingButton}
            onClick={this.handleButtonClick}
          >
            <div className={classes.iconContainerEvah}>
              {this.state.evahIaRecordingState ? (
                <div className={classes.soundWaveAnimation}>
                  <div className={classes.wave}></div>
                  <div className={classes.wave}></div>
                  <div className={classes.wave}></div>
                </div>
              ) : (
                <EvahIaIcon size="24px" color="#ffff" />
              )}
            </div>
          </button>
        )}
        
        {prontuarioStore.openModalEvahIa && (
          <ModalEvahIa
            open={prontuarioStore.openModalEvahIa}
            onClose={this.handleModalClose}
            handleMinimize={this.handleModalMinimize}
            recordingState={this.state.evahIaRecordingState}
            onRecordingChange={this.handleRecordingChange}
            isMinimized={prontuarioStore.minimizedModalEvahIa}
            idAgendamento={prontuarioStore.agendamentoSelectedIA}
            sujeitoAtencao={prontuarioStore.sujeitoAtencaoSelectedIA}
            openNotification={this.handleOpenNotification}
          />
        )}
        
      <ConfirmAlertModal
          open={this.state.showCloseAlert}
          onClose={() => this.setState({ showCloseAlert: false })}
          onCancel={this.handleCancelAlert}
          onConfirm={this.handleConfirmClose}
          title="Fechar Escuta Inteligente"
          text="Ao fechar o modal, a Escuta Inteligente será desativada. Você pode minimizar para mantê-la ativa."
          titleSecundaryButton="Minimizar"
          titlePrimaryButton="Fechar"
        />
        <Notification
          close={e => prontuarioStore.closeNotification(e)}
          reset={() => prontuarioStore.resetNotification()}
          isOpen={prontuarioStore.notification.isOpen}
          variant={prontuarioStore.notification.variant}
          message={prontuarioStore.notification.message}
        />
      </>
    );
  }
}

export default withStyles(styles)(EvahIaFloatingButton);